const DEFAULT_BADGE_BACKGROUND = '#858484'
const DEFAULT_BADGE_TEXT = '#FFFFFF'
const FALLBACK_LOGO_SRC = '/img/skop-logo.png'

const HEX_COLOR_PATTERN = /^#([\da-f]{3}|[\da-f]{6})$/i

const normalizeHexColor = (value: unknown): string | null => {
  if (typeof value !== 'string') return null

  const color = value.trim()
  if (!HEX_COLOR_PATTERN.test(color)) return null

  if (color.length === 4) {
    return `#${color
      .slice(1)
      .split('')
      .map((channel) => channel + channel)
      .join('')}`.toUpperCase()
  }

  return color.toUpperCase()
}

const hexToRgb = (value: string) => ({
  r: Number.parseInt(value.slice(1, 3), 16),
  g: Number.parseInt(value.slice(3, 5), 16),
  b: Number.parseInt(value.slice(5, 7), 16),
})

const toRelativeLuminance = (channel: number) => {
  const normalized = channel / 255
  return normalized <= 0.03928
    ? normalized / 12.92
    : ((normalized + 0.055) / 1.055) ** 2.4
}

const getLuminance = (value: string) => {
  const { r, g, b } = hexToRgb(value)
  return (
    0.2126 * toRelativeLuminance(r) +
    0.7152 * toRelativeLuminance(g) +
    0.0722 * toRelativeLuminance(b)
  )
}

const getContrastRatio = (foreground: number, background: number) => {
  const lightest = Math.max(foreground, background)
  const darkest = Math.min(foreground, background)
  return (lightest + 0.05) / (darkest + 0.05)
}

export const getPdfBadgeColors = (value: unknown) => {
  const backgroundColor = normalizeHexColor(value)

  if (!backgroundColor) {
    return {
      backgroundColor: DEFAULT_BADGE_BACKGROUND,
      color: DEFAULT_BADGE_TEXT,
    }
  }

  const backgroundLuminance = getLuminance(backgroundColor)
  const blackContrast = getContrastRatio(0, backgroundLuminance)
  const whiteContrast = getContrastRatio(1, backgroundLuminance)

  return {
    backgroundColor,
    color: blackContrast >= whiteContrast ? '#000000' : '#FFFFFF',
  }
}

export const PDF_FALLBACK_LOGO_SRC = FALLBACK_LOGO_SRC
